;(function( window, document, $, undefined ) {
	'use strict';

	// Column Stretch

	function columnStretch() {

    // Background
    function background( $target ) {
      $('.column-stretch').each(function(){
        var $this = $(this);
        var elBackground = $this.find('.vc_column-inner').css('background-color');
        var $parent = $this.closest('.columns-stretch-wrap');
        $parent.append( '<div class="column-stretch-bg" style="background-color: ' + elBackground + ';"></div>' );

      });

      function bgPosition() {
        $('.column-stretch-bg').each(function(){
          var $this = $(this);
          var $parent = $this.closest('.columns-stretch-wrap');
          var $contentStretch = $parent.find('.column-stretch');
          var elPositionLeft = $contentStretch.offset().left;
          var elWidth = ($(window).width() - elPositionLeft);

          var elPositionTop = $contentStretch.offset().top;
          var parentPositionTop = $parent.offset().top;
          var elHeight = (elPositionTop - parentPositionTop);

          $this.css({
            width: elWidth,
            left: elPositionLeft,
            top: elHeight
          });
        });
      }

      bgPosition();
      $(window).resize(function(){
        window.setTimeout(function(){
          bgPosition();
        }, 100);
      });
    }

		// Globals
		return {
      background: background
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.columnStretch = columnStretch();

})( window, document, jQuery );
